module.exports = __webpack_public_path__ + "assets/img/img131.faa9d88f.png";